'use strict';

/**
 * 禁用掉手机的返回键，不然安卓的返回键会回退到一个空页面，造成卡死
 */
(function () {
  var ua = navigator.userAgent;
  if (/android/gi.test(ua) && !/micromessenger/gi.test(ua) && typeof window.history !== 'undefined') {
    window.history.pushState(null, null, document.URL);
    window.addEventListener('popstate', function () {
      window.history.pushState(null, null, document.URL);
    });
  }
})();